import ControllerBase from 'global/js/ControllerBase';
const autoSuggestionHitsMolecule = require('components/molecules/m-search-autosuggestion-hits/m-search-autosuggestion-hits.template.twig') as any;

const PREFIX = 'SearchSuggestionResults__'

export const SearchSuggestionResultsEvents = {
	UPDATE_SEARCH_SUGGESTION_RESULTS: PREFIX + 'UPDATE_RESULTS'
}

interface ComponentRefs {
	resultsContainer: 'resultsContainer';
}

export default class ControllerSearchAutoSuggestionResults extends ControllerBase<ComponentRefs> {
	private resultsContainer: HTMLDivElement;
	private static readonly componentRefs: ComponentRefs = {
		resultsContainer: 'resultsContainer'
	}

	constructor(element: HTMLElement) {
		super(element, [], Object.values(ControllerSearchAutoSuggestionResults.componentRefs));
		this.init();
	}

	private init(): void {
		this.registerEvents()
		this.resultsContainer = this.$references.resultsContainer as HTMLDivElement;
	}

	private refreshResults = (event: CustomEvent) => {
		this.domUtils.renderDomElement(
			ControllerSearchAutoSuggestionResults.componentRefs.resultsContainer,
			autoSuggestionHitsMolecule({ data: event.detail }),
			true
		)
		const isTouchSupported = 'ontouchstart' in window || window.navigator.maxTouchPoints;
		const suggestionList = this.$element.querySelectorAll('.m-search-autosuggestion-hits__result-row') as NodeListOf<HTMLElement>;
		for (let i = 0; i < suggestionList.length; i++) {
			if (isTouchSupported) suggestionList[i].style.display = (i < 5 ? 'flex' : 'none');
		}

	}

	private registerEvents() {
		window.addEventListener(SearchSuggestionResultsEvents.UPDATE_SEARCH_SUGGESTION_RESULTS, this.refreshResults)
	}

}
